import { NgModule } from '@angular/core';
import { AutoSaveComponent } from './auto-save.component';

@NgModule({
  declarations: [
    AutoSaveComponent
  ],
  exports: [
    AutoSaveComponent
  ]
})

export class AutoSaveModule {}
